var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container osummary summary mt-3" },
    [
      _c("loading", {
        attrs: { active: _vm.loading, "can-cancel": false },
        on: {
          "update:active": function ($event) {
            _vm.loading = $event
          },
        },
      }),
      !_vm.data.selected.unit
        ? _c(
            "div",
            {
              staticClass: "alert alert-danger text-center",
              attrs: { role: "alert" },
            },
            [
              _c("h2", { staticClass: "text-danger" }, [
                _vm._v(" " + _vm._s(_vm.$t("pleaseSelectUnit")) + " "),
              ]),
            ]
          )
        : _vm._e(),
      !_vm.data.navBarRefresh && _vm.data.selected.unit
        ? _c("div", [
            _c("div", { staticClass: "row mt-2" }, [
              _c("div", { staticClass: "col-12 text-center" }, [
                _c("h2", [_vm._v(_vm._s(_vm.$t("outageSummaryTitle")))]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "row mt-2 justify-content-center w-100" },
              [
                _c(
                  "pui-tabs",
                  {
                    attrs: { selected: _vm.showOutagePlanning ? 0 : 1 },
                    on: { changed: _vm.toggleOutagePlanning },
                  },
                  _vm._l(_vm.tabs, function (tab, index) {
                    return _c("pui-tab", {
                      key: "tab-" + index,
                      attrs: { title: _vm.$t(tab) },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "row my-2 legend" }, [
              _c("div", { staticClass: "col-6 text-right" }, [
                _c("span", { staticClass: "legend-budget" }),
                _c("p", [_vm._v(_vm._s(_vm.$t("budgetVal")))]),
              ]),
              !_vm.showOutagePlanning
                ? _c("div", { staticClass: "col-6 text-left" }, [
                    _c("span", {
                      staticClass: "legend-calculated text-center",
                    }),
                    _c("p", [_vm._v(_vm._s(_vm.$t("calculatedVal")))]),
                  ])
                : _vm._e(),
              _vm.showOutagePlanning
                ? _c("div", { staticClass: "col-6 text-left" }, [
                    _c("span", { staticClass: "legend-nominated-date" }),
                    _c("p", [_vm._v(_vm._s(_vm.$t("nominatedDate")))]),
                  ])
                : _vm._e(),
            ]),
            _c(
              "div",
              {
                staticClass:
                  "row mt-2 flex-nowrap w-100 justify-content-around",
              },
              [
                !_vm.showOutagePlanning
                  ? _c("div", { staticClass: "col-2" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-primary",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.navigateToOutageDocuments()
                            },
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("outageDocuments"))),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm.showOutagePlanning
                  ? _c("div", { staticClass: "col-2 pl-0" }, [
                      _c("div", { staticClass: "input-group input-group-sm" }, [
                        _c("div", { staticClass: "input-group-prepend" }, [
                          _c("span", { staticClass: "input-group-text" }, [
                            _vm._v(_vm._s(_vm.$t("year"))),
                          ]),
                        ]),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedYear,
                                expression: "selectedYear",
                              },
                            ],
                            staticClass: "custom-select custom-select-sm",
                            on: {
                              change: [
                                function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.selectedYear = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                function ($event) {
                                  return _vm.handleYearChange()
                                },
                              ],
                            },
                          },
                          _vm._l(_vm.yearSelection, function (year) {
                            return _c(
                              "option",
                              {
                                key: "selected-year-" + year,
                                domProps: { value: year },
                              },
                              [_vm._v(" " + _vm._s(year) + " ")]
                            )
                          }),
                          0
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "col-3" }, [
                  _c("div", { staticClass: "input-group input-group-sm" }, [
                    _c("div", { staticClass: "input-group-prepend" }, [
                      _c("span", { staticClass: "input-group-text" }, [
                        _vm._v(_vm._s(_vm.$t("visibleValues"))),
                      ]),
                    ]),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.visibleValuesSelected,
                            expression: "visibleValuesSelected",
                          },
                        ],
                        staticClass: "custom-select custom-select-sm",
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.visibleValuesSelected = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            _vm.refresh,
                          ],
                        },
                      },
                      _vm._l(
                        _vm.visibleValuesSelection,
                        function (visibleValue) {
                          return _c(
                            "option",
                            {
                              key: "visible-value-" + visibleValue.value,
                              domProps: { value: visibleValue.value },
                            },
                            [_vm._v(" " + _vm._s(visibleValue.label) + " ")]
                          )
                        }
                      ),
                      0
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "col-3" }, [
                  !_vm.showOutagePlanning ||
                  (_vm.showOutagePlanning &&
                    _vm.visibleValuesSelected !==
                      _vm.visibleValuesOutageAnnualPreview.nominatedDatesOnly)
                    ? _c("div", { staticClass: "input-group input-group-sm" }, [
                        _c("div", { staticClass: "input-group-prepend" }, [
                          _c("span", { staticClass: "input-group-text" }, [
                            _vm._v(_vm._s(_vm.$t("viewMode"))),
                          ]),
                        ]),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.viewSelected,
                                expression: "viewSelected",
                              },
                            ],
                            staticClass: "custom-select custom-select-sm",
                            on: {
                              change: [
                                function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.viewSelected = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                function ($event) {
                                  return _vm.populateShortInfos()
                                },
                              ],
                            },
                          },
                          _vm._l(_vm.viewSelection, function (view) {
                            return _c(
                              "option",
                              {
                                key: "view-selection-" + view.value,
                                domProps: { value: view.value },
                              },
                              [_vm._v(" " + _vm._s(view.label) + " ")]
                            )
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "col-2 text-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-sm mr-1",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.print()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("print")) + " ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-sm",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.takeScreenShot()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("takeScreenshot")) + " ")]
                  ),
                ]),
              ]
            ),
            !_vm.showOutagePlanning
              ? _c("h2", { attrs: { id: "printTitle" } }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.data.selected.group.name) +
                      " " +
                      _vm._s(_vm.$t("outageSummary")) +
                      " "
                  ),
                ])
              : _vm._e(),
            _vm.showOutagePlanning
              ? _c("h2", { attrs: { id: "printTitle" } }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.data.selected.group.name) +
                      " " +
                      _vm._s(_vm.$t("outagePlan")) +
                      " " +
                      _vm._s(_vm.selectedYear) +
                      " "
                  ),
                ])
              : _vm._e(),
            !_vm.showOutagePlanning
              ? _c(
                  "div",
                  {
                    staticClass:
                      "overflow-y-scroll summary-table pl-0 ml-0 mt-2",
                    attrs: { id: "vertical-scroll" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "row pl-0 ml-0 summary-table-header" },
                      [
                        _c(
                          "div",
                          { staticClass: "col-3 pl-0 ml-0 pr-0 freezeView" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "summary-table-antet title table-antet",
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "title1" },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "angle-down" },
                                    }),
                                    _vm._v(" " + _vm._s(_vm.$t("unit")) + " "),
                                  ],
                                  1
                                ),
                                _c(
                                  "span",
                                  { staticClass: "title2" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getCurrentViewMode(_vm.viewMode)
                                        ) +
                                        " "
                                    ),
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "angle-right" },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "col-9 pl-0 ml-0 pr-0" }, [
                          _c(
                            "div",
                            {
                              staticClass: "summary-table-content-header",
                              class: {
                                yearsHeader:
                                  _vm.viewMode === _vm.viewModes.YEARS,
                                monthsHeader:
                                  _vm.viewMode === _vm.viewModes.MONTHS,
                              },
                              style: {
                                width:
                                  _vm.numOfCols * _vm.headerCellWidth + "px",
                              },
                            },
                            _vm._l(_vm.tableHeader, function (item, index) {
                              return _c("div", {
                                key: "tableHeader-" + index,
                                staticClass: "summary-table-header",
                                style: { width: _vm.headerCellWidth + "px" },
                                domProps: { innerHTML: _vm._s(item) },
                              })
                            }),
                            0
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "summary-table-content",
                        on: {
                          mouseenter: function ($event) {
                            return _vm.initTooltips()
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "row summary-table-row pl-0 ml-0" },
                          _vm._l(
                            _vm.tableData.plants,
                            function (plant, plantIndex) {
                              return _c(
                                "div",
                                {
                                  key: plantIndex,
                                  staticClass: "col-12 pl-0 ml-0 mr-0 pr-0",
                                  attrs: { id: "plant-" + plantIndex },
                                },
                                _vm._l(plant.units, function (unit, unitIndex) {
                                  return _c(
                                    "div",
                                    {
                                      key: unitIndex,
                                      staticClass: "col-12 pl-0 ml-0 mr-0 pr-0",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row pl-0 ml-0 pb-0 mb-0 pr-0 mr-0",
                                          style: {
                                            height: _vm.tableRowHeight + "px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row-border col-3 freezeView col-3-content text-ovflow-ellipsis pl-0 ml-0 pb-0 mb-0 pr-0 mr-0",
                                              style: {
                                                "background-color":
                                                  (plantIndex + unitIndex) %
                                                    2 ===
                                                  1
                                                    ? "#f4f5f7"
                                                    : "#fff",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "item-title" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(plant.name) +
                                                      " - " +
                                                      _vm._s(unit.name) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-9 pl-0 ml-0 pb-0 mb-0 pr-0 mr-0",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row-border area-totals-wrapper",
                                                  style: {
                                                    width:
                                                      _vm.numOfCols *
                                                        _vm.headerCellWidth +
                                                      "px",
                                                    height:
                                                      _vm.tableRowHeight + "px",
                                                    "background-color":
                                                      (plantIndex + unitIndex) %
                                                        2 ===
                                                      1
                                                        ? "#f3f5f7"
                                                        : "#fff",
                                                  },
                                                },
                                                [
                                                  _vm._l(
                                                    _vm.getOutagesToDisplay(
                                                      unit.budgets
                                                    ),
                                                    function (budget, index) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            key:
                                                              "budgetItem-" +
                                                              index,
                                                            staticClass:
                                                              "budget-item",
                                                            style: {
                                                              width:
                                                                budget.width +
                                                                "px",
                                                              left:
                                                                budget.left +
                                                                "px",
                                                            },
                                                            attrs: {
                                                              "data-toggle":
                                                                "tooltip",
                                                              "data-placement":
                                                                "left",
                                                              title:
                                                                _vm.getBudgetTitle(
                                                                  budget,
                                                                  plant
                                                                ),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.populateModal(
                                                                  budget,
                                                                  unit.name,
                                                                  plant.currency
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "outage-short-info",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getShortInfo(
                                                                        true,
                                                                        unit.plantId,
                                                                        unit.id,
                                                                        budget.left
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    }
                                                  ),
                                                  _vm._l(
                                                    _vm.getOutagesToDisplay(
                                                      unit.calculated
                                                    ),
                                                    function (
                                                      calculatedItem,
                                                      index
                                                    ) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            key:
                                                              "calculatedItem-" +
                                                              index,
                                                            staticClass:
                                                              "calculated-item",
                                                            style: {
                                                              width:
                                                                calculatedItem.width +
                                                                "px",
                                                              left:
                                                                calculatedItem.left +
                                                                "px",
                                                            },
                                                            attrs: {
                                                              "data-toggle":
                                                                "tooltip",
                                                              "data-placement":
                                                                "left",
                                                              title:
                                                                _vm.getCalculatedItemTitle(
                                                                  calculatedItem,
                                                                  plant
                                                                ),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.populateModal(
                                                                  calculatedItem,
                                                                  unit.name,
                                                                  plant.currency
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "outage-short-info",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getShortInfo(
                                                                        false,
                                                                        unit.plantId,
                                                                        unit.id,
                                                                        calculatedItem.left
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                              _vm._l(
                                                _vm.yearLines,
                                                function (year, index) {
                                                  return _c("div", {
                                                    key: "year-" + index,
                                                    staticStyle: {
                                                      "border-right":
                                                        "1px solid #cfd0d2",
                                                      width: "1px",
                                                      position: "absolute",
                                                      top: "0",
                                                      bottom: "0",
                                                    },
                                                    style: {
                                                      left:
                                                        year *
                                                          _vm.headerCellWidth *
                                                          (_vm.viewMode ===
                                                          _vm.viewModes.YEARS
                                                            ? 1
                                                            : _vm.viewMode ===
                                                              _vm.viewModes
                                                                .QUARTERS
                                                            ? 4
                                                            : 12) -
                                                        1 +
                                                        "px",
                                                    },
                                                  })
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              )
                            }
                          ),
                          0
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm.showOutagePlanning
              ? _c(
                  "div",
                  {
                    staticClass: "row",
                    attrs: { id: "outagePlanningContainer" },
                  },
                  [
                    !_vm.loading
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "overflow-y-scroll summary-table pl-0 ml-0 mt-2",
                            attrs: { id: "vertical-scroll" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "row pl-0 ml-0 summary-table-header",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-3 pl-0 ml-0 pr-0 freezeView",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "summary-table-antet title table-antet",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "title1" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(_vm.$t("unit")) + " "
                                            ),
                                            _c("font-awesome-icon", {
                                              attrs: { icon: "angle-down" },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "title2" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("months")) +
                                                " "
                                            ),
                                            _c("font-awesome-icon", {
                                              attrs: { icon: "angle-right" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "col-9 pl-0 ml-0 pr-0",
                                    attrs: { id: "headerMonths" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "summary-table-content-header",
                                        class: { monthsHeader: true },
                                        style: {
                                          width:
                                            _vm.numOfCols *
                                              _vm.headerCellWidth +
                                            "px",
                                        },
                                      },
                                      _vm._l(
                                        _vm.tableHeader,
                                        function (item, index) {
                                          return _c("div", {
                                            key: "tableHeaderItem-" + index,
                                            staticClass: "summary-table-header",
                                            style: {
                                              width:
                                                (_vm.numOfCols *
                                                  _vm.headerCellWidth) /
                                                  12 +
                                                "px",
                                            },
                                            domProps: {
                                              innerHTML: _vm._s(item),
                                            },
                                          })
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "summary-table-content" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "row summary-table-row pl-0 ml-0",
                                  },
                                  _vm._l(
                                    _vm.tableData.plants,
                                    function (plant, plantIndex) {
                                      return _c(
                                        "div",
                                        {
                                          key: plantIndex,
                                          staticClass:
                                            "col-12 pl-0 ml-0 mr-0 pr-0",
                                          attrs: { id: "plant-" + plantIndex },
                                        },
                                        _vm._l(
                                          plant.units,
                                          function (unit, unitIndex) {
                                            return _c(
                                              "div",
                                              {
                                                key: unitIndex,
                                                staticClass:
                                                  "col-12 pl-0 ml-0 mr-0 pr-0",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "row pl-0 ml-0 pb-0 mb-0 pr-0 mr-0",
                                                    style: {
                                                      height:
                                                        _vm.tableRowHeight +
                                                        "px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "row-border col-3 freezeView col-3-content text-ovflow-ellipsis pl-0 ml-0 pb-0 mb-0 pr-0 mr-0",
                                                        style: {
                                                          "background-color":
                                                            (plantIndex +
                                                              unitIndex) %
                                                              2 ===
                                                            1
                                                              ? "#f4f5f7"
                                                              : "#fff",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "item-title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  plant.name
                                                                ) +
                                                                " - " +
                                                                _vm._s(
                                                                  unit.name
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-9 pl-0 ml-0 pb-0 mb-0 pr-0 mr-0",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "row-border area-totals-wrapper",
                                                            style: {
                                                              width:
                                                                _vm.numOfCols *
                                                                  _vm.headerCellWidth +
                                                                "px",
                                                              height:
                                                                _vm.tableRowHeight +
                                                                "px",
                                                              "background-color":
                                                                (plantIndex +
                                                                  unitIndex) %
                                                                  2 ===
                                                                1
                                                                  ? "#f3f5f7"
                                                                  : "#fff",
                                                            },
                                                          },
                                                          [
                                                            _vm._l(
                                                              _vm.getOutagesToDisplay(
                                                                unit.budgets
                                                              ),
                                                              function (
                                                                budget,
                                                                budgetIndex
                                                              ) {
                                                                return [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      key: budgetIndex,
                                                                      staticClass:
                                                                        "budget-item",
                                                                      style: {
                                                                        width:
                                                                          budget.width +
                                                                          "px",
                                                                        left:
                                                                          budget.left +
                                                                          "px",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.populateModal(
                                                                              budget,
                                                                              unit.name,
                                                                              plant.currency
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "outage-short-info",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.getShortInfo(
                                                                                  true,
                                                                                  unit.plantId,
                                                                                  unit.id,
                                                                                  budget.left
                                                                                )
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              }
                                                            ),
                                                            _vm._l(
                                                              _vm.getOutagesToDisplay(
                                                                unit.nominatedDates
                                                              ),
                                                              function (
                                                                nominatedDate,
                                                                index
                                                              ) {
                                                                return [
                                                                  _c("div", {
                                                                    key:
                                                                      "nominatedDate-" +
                                                                      index,
                                                                    staticClass:
                                                                      "nominated-date",
                                                                    style: {
                                                                      width:
                                                                        nominatedDate.width +
                                                                        "px",
                                                                      left:
                                                                        nominatedDate.left +
                                                                        "px",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.populateModal(
                                                                            nominatedDate,
                                                                            unit.name,
                                                                            plant.currency
                                                                          )
                                                                        },
                                                                    },
                                                                  }),
                                                                ]
                                                              }
                                                            ),
                                                          ],
                                                          2
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _c("div", {
              staticStyle: { display: "none" },
              attrs: { id: "screenCapture" },
            }),
            !_vm.showOutagePlanning
              ? _c(
                  "div",
                  {
                    staticClass: "zoom zoom2",
                    class: { bottonZoom: _vm.showZoom === true },
                    on: {
                      click: function ($event) {
                        _vm.showZoom = !_vm.showZoom
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "content" }, [
                      _c("span", [_vm._v(_vm._s(_vm.$t("zoom")))]),
                    ]),
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "zoom-content",
                class: { bottonZoom: _vm.showZoom === true },
              },
              [
                _c("ul", { staticClass: "tooltip-inner-custom" }, [
                  _c(
                    "li",
                    {
                      class: {
                        selected_custom: _vm.viewMode === _vm.viewModes.YEARS,
                      },
                      on: {
                        click: function ($event) {
                          _vm.changeViewMode(_vm.viewModes.YEARS)
                          _vm.showZoom = !_vm.showZoom
                        },
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("y")))])]
                  ),
                  _c(
                    "li",
                    {
                      class: {
                        selected_custom:
                          _vm.viewMode === _vm.viewModes.QUARTERS,
                      },
                      on: {
                        click: function ($event) {
                          _vm.changeViewMode(_vm.viewModes.QUARTERS)
                          _vm.showZoom = !_vm.showZoom
                        },
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("q")))])]
                  ),
                  _c(
                    "li",
                    {
                      class: {
                        selected_custom: _vm.viewMode === _vm.viewModes.MONTHS,
                      },
                      on: {
                        click: function ($event) {
                          _vm.changeViewMode(_vm.viewModes.MONTHS)
                          _vm.showZoom = !_vm.showZoom
                        },
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("m")))])]
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "filter-show",
                class: { "visible-button": _vm.filterVisible },
                on: {
                  click: function ($event) {
                    _vm.filterVisible = !_vm.filterVisible
                  },
                },
              },
              [
                _c("div", { staticClass: "content" }, [
                  _c(
                    "span",
                    [
                      _vm._v(" " + _vm._s(_vm.$t("filter")) + " "),
                      _c("font-awesome-icon", {
                        attrs: { icon: "angle-down" },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "filter-container pt-3 pb-2 pl-2 pr-2",
                class: [{ visible: _vm.filterVisible }],
              },
              [
                _c("h6", [
                  _vm._v(
                    _vm._s(_vm.$t("plant")) + " / " + _vm._s(_vm.$t("unit"))
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "filter-hide text-center filter-button",
                    on: {
                      click: function ($event) {
                        _vm.filterVisible = !_vm.filterVisible
                      },
                    },
                  },
                  [_vm._v(" × ")]
                ),
                _c(
                  "ul",
                  { staticClass: "filter pl-2 pr-2" },
                  [
                    _c("li", { staticClass: "filter-header" }, [
                      _c("div", { staticClass: "form-check area-item" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.showMostImportantOutages,
                              expression: "showMostImportantOutages",
                            },
                          ],
                          attrs: { type: "checkbox", id: "showMostImportant" },
                          domProps: {
                            checked: Array.isArray(_vm.showMostImportantOutages)
                              ? _vm._i(_vm.showMostImportantOutages, null) > -1
                              : _vm.showMostImportantOutages,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.showMostImportantOutages,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.showMostImportantOutages = $$a.concat([
                                      $$v,
                                    ]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.showMostImportantOutages = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.showMostImportantOutages = $$c
                              }
                            },
                          },
                        }),
                        _c("label", { attrs: { for: "showMostImportant" } }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("showMajorOverhauls")) + " "
                          ),
                        ]),
                      ]),
                    ]),
                    _c("li", [
                      _c(
                        "div",
                        {
                          staticClass: "form-check area-item",
                          staticStyle: { "background-color": "#f3f5f7" },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.allSelected,
                                expression: "allSelected",
                              },
                            ],
                            attrs: { type: "checkbox", id: "selectAll" },
                            domProps: {
                              checked: Array.isArray(_vm.allSelected)
                                ? _vm._i(_vm.allSelected, null) > -1
                                : _vm.allSelected,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.allSelected,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.allSelected = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.allSelected = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.allSelected = $$c
                                  }
                                },
                                function ($event) {
                                  return _vm.onSelectAllChange(_vm.allSelected)
                                },
                              ],
                            },
                          }),
                          _c("label", { attrs: { for: "selectAll" } }, [
                            _vm._v(" " + _vm._s(_vm.$t("selectAll")) + " "),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._l(_vm.outageFilter, function (plant, plantIndex) {
                      return _c(
                        "li",
                        { key: plantIndex, staticClass: "filter-header" },
                        [
                          _c("div", { class: ["form-check", "area-item"] }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: plant.selected,
                                  expression: "plant.selected",
                                },
                              ],
                              attrs: {
                                id: "plantFilter-" + plantIndex,
                                type: "checkbox",
                              },
                              domProps: {
                                checked: Array.isArray(plant.selected)
                                  ? _vm._i(plant.selected, null) > -1
                                  : plant.selected,
                              },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$a = plant.selected,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            plant,
                                            "selected",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            plant,
                                            "selected",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(plant, "selected", $$c)
                                    }
                                  },
                                  function ($event) {
                                    return _vm.onPlantFilterChange(
                                      $event,
                                      plant
                                    )
                                  },
                                ],
                              },
                            }),
                            _c(
                              "label",
                              { attrs: { for: "plantFilter-" + plantIndex } },
                              [_vm._v(" " + _vm._s(plant.name) + " ")]
                            ),
                          ]),
                          plant.units !== undefined && plant.units.length > 0
                            ? _c(
                                "ul",
                                { staticClass: "sub-filter" },
                                _vm._l(plant.units, function (item, itemIndex) {
                                  return _c(
                                    "li",
                                    {
                                      key: itemIndex,
                                      class: [
                                        "filter-item",
                                        _vm.getRowClass(itemIndex),
                                      ],
                                    },
                                    [
                                      _c("div", { staticClass: "form-check" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: item.selected,
                                              expression: "item.selected",
                                            },
                                          ],
                                          attrs: {
                                            id:
                                              "plantFilter-" +
                                              plantIndex +
                                              "-item-" +
                                              itemIndex,
                                            type: "checkbox",
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              item.selected
                                            )
                                              ? _vm._i(item.selected, null) > -1
                                              : item.selected,
                                          },
                                          on: {
                                            change: [
                                              function ($event) {
                                                var $$a = item.selected,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        item,
                                                        "selected",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        item,
                                                        "selected",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    item,
                                                    "selected",
                                                    $$c
                                                  )
                                                }
                                              },
                                              function ($event) {
                                                return _vm.onUnitFilterChange(
                                                  $event,
                                                  plant,
                                                  item
                                                )
                                              },
                                            ],
                                          },
                                        }),
                                        _c(
                                          "label",
                                          {
                                            attrs: {
                                              for:
                                                "plantFilter-" +
                                                plantIndex +
                                                "-item-" +
                                                itemIndex,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(item.name) + " "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                        ]
                      )
                    }),
                  ],
                  2
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-sm mt-1",
                    on: { click: _vm.refresh },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("refresh")) + " ")]
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "modal",
                attrs: { tabindex: "-1", role: "dialog", id: "detailOutage" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "modal-dialog modal-lg modal-dialog-centered",
                    attrs: { role: "document" },
                  },
                  [
                    _c("div", { staticClass: "modal-content" }, [
                      _c("div", { staticClass: "modal-header" }, [
                        _c("h5", { staticClass: "modal-title" }, [
                          _vm._v(" " + _vm._s(_vm.modalData.title) + " "),
                        ]),
                        _vm._m(0),
                      ]),
                      _c("div", { staticClass: "modal-body" }, [
                        _c(
                          "table",
                          [
                            _c("tr", [
                              _c("th", [_vm._v(" ")]),
                              _c("th", [_vm._v(_vm._s(_vm.$t("title")))]),
                              _c("th", [_vm._v(_vm._s(_vm.$t("duration")))]),
                              _c("th", [_vm._v(_vm._s(_vm.$t("startDate")))]),
                              _c("th", [_vm._v(_vm._s(_vm.$t("endDate")))]),
                              _c("th", [
                                _vm._v(
                                  _vm._s(_vm.$t("cost")) +
                                    " (K" +
                                    _vm._s(_vm.modalData.currency) +
                                    ")"
                                ),
                              ]),
                              _c("th", [_vm._v(_vm._s(_vm.$t("currency")))]),
                            ]),
                            _vm._l(_vm.modalData.details, function (c, index) {
                              return _c("tr", { key: "details-" + index }, [
                                _c("td", [_vm._v(_vm._s(c.title))]),
                                _c("td", [_vm._v(_vm._s(c.description))]),
                                _c("td", [_vm._v(_vm._s(c.duration))]),
                                _c("td", [
                                  c.startDate
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getFormattedDate(c.startDate)
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                                _c("td", [
                                  c.endDate
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getFormattedDate(c.endDate)
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                                _c("td", { staticClass: "doubble-line" }, [
                                  _c("div", [
                                    c.costDescription
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(c.costDescription) + ":"
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" " + _vm._s(c.cost)),
                                  ]),
                                  _c("div", [
                                    c.cost2Description
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(c.cost2Description) + ":"
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" " + _vm._s(c.cost2) + " "),
                                  ]),
                                ]),
                                _c("td", [_vm._v(_vm._s(c.currency))]),
                              ])
                            }),
                          ],
                          2
                        ),
                      ]),
                      _vm._m(1),
                    ]),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "modal",
                attrs: {
                  tabindex: "-1",
                  role: "dialog",
                  id: "annual-outage-details-modal",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "modal-dialog modal-lg modal-dialog-centered",
                    style: {
                      width: _vm.isUnlinkedNominatedDate() ? "800px" : "1500px",
                    },
                    attrs: { role: "document" },
                  },
                  [
                    _c("div", { staticClass: "modal-content" }, [
                      _c("div", { staticClass: "modal-header" }, [
                        _c("h5", { staticClass: "modal-title" }, [
                          _vm._v(" " + _vm._s(_vm.modalData.title) + " "),
                        ]),
                        _vm._m(2),
                      ]),
                      _c(
                        "div",
                        { staticClass: "modal-body table-responsive" },
                        [
                          !_vm.isUnlinkedNominatedDate()
                            ? _c(
                                "table",
                                { staticClass: "table table-sm" },
                                [
                                  _c("tr", { staticClass: "text-center" }, [
                                    _c("th", { attrs: { rowspan: "2" } }, [
                                      _vm._v("   "),
                                    ]),
                                    _c("th", { attrs: { rowspan: "2" } }, [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("title")) + " "
                                      ),
                                    ]),
                                    _c("th", { attrs: { rowspan: "2" } }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("budget")) +
                                          " (K" +
                                          _vm._s(_vm.modalData.currency) +
                                          ") "
                                      ),
                                    ]),
                                    _c("th", { attrs: { rowspan: "2" } }, [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("duration")) + " "
                                      ),
                                    ]),
                                    _c("th", { attrs: { rowspan: "2" } }, [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("startDate")) + " "
                                      ),
                                    ]),
                                    _c("th", { attrs: { rowspan: "2" } }, [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("endDate")) + " "
                                      ),
                                    ]),
                                    _c("th", { attrs: { rowspan: "2" } }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("outageModalCommercialValue")
                                          ) +
                                          " (K" +
                                          _vm._s(_vm.modalData.currency) +
                                          ") "
                                      ),
                                    ]),
                                    _c("th", { attrs: { colspan: "3" } }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("outageRiskOfExtension")
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("tr", { staticClass: "text-center" }, [
                                    _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "outageExtensionTechnicalProbability"
                                          )
                                        )
                                      ),
                                    ]),
                                    _c("th", [
                                      _vm._v(
                                        _vm._s(_vm.$t("outageExtensionDays"))
                                      ),
                                    ]),
                                    _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("outageModalCommercailImpact")
                                        ) +
                                          " (K" +
                                          _vm._s(_vm.modalData.currency) +
                                          ")"
                                      ),
                                    ]),
                                  ]),
                                  _vm._l(
                                    _vm.modalData.details,
                                    function (c, index) {
                                      return _c(
                                        "tr",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !c.hidden,
                                              expression: "!c.hidden",
                                            },
                                          ],
                                          key: "modal-details-" + index,
                                        },
                                        [
                                          _c("td", [_vm._v(_vm._s(c.title))]),
                                          _c("td", [
                                            _vm._v(_vm._s(c.description)),
                                          ]),
                                          _c("td", [_vm._v(_vm._s(c.cost))]),
                                          _c("td", [
                                            _vm._v(_vm._s(c.duration)),
                                          ]),
                                          _c("td", [
                                            c.startDate
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getFormattedDate(
                                                        c.startDate
                                                      )
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]),
                                          _c("td", [
                                            c.endDate
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getFormattedDate(
                                                        c.endDate
                                                      )
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]),
                                          _c(
                                            "td",
                                            { staticClass: "doubble-line" },
                                            [
                                              c.commercialValueIntrinsic != null
                                                ? _c("div", [
                                                    _vm._v(
                                                      " IV: " +
                                                        _vm._s(
                                                          c.commercialValueIntrinsic
                                                        ) +
                                                        " "
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              c.commercialValueExtrinsic != null
                                                ? _c("div", [
                                                    _vm._v(
                                                      " EV: " +
                                                        _vm._s(
                                                          c.commercialValueExtrinsic
                                                        ) +
                                                        " "
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          ),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(c.technicalProbability)
                                            ),
                                          ]),
                                          _c("td", [
                                            _vm._v(_vm._s(c.extensionDays)),
                                          ]),
                                          _c(
                                            "td",
                                            { staticClass: "doubble-line" },
                                            [
                                              c.commercialImpactIntrinsic !=
                                              null
                                                ? _c("div", [
                                                    _vm._v(
                                                      " IV: " +
                                                        _vm._s(
                                                          c.commercialImpactIntrinsic
                                                        ) +
                                                        " "
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              c.commercialImpactExtrinsic !=
                                              null
                                                ? _c("div", [
                                                    _vm._v(
                                                      " EV: " +
                                                        _vm._s(
                                                          c.commercialImpactExtrinsic
                                                        ) +
                                                        " "
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm.modalData.details &&
                                  _vm.modalData.details.length > 2
                                    ? _c("tr", [
                                        _c("td", { attrs: { colspan: "10" } }, [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-sm btn-default",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toggleModalDetails(
                                                    _vm.modalDetailsExpanded
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm.modalDetailsExpanded
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "outageModalCollapse"
                                                        )
                                                      )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              !_vm.modalDetailsExpanded
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "outageModalExpand"
                                                        )
                                                      )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm.isUnlinkedNominatedDate()
                            ? _c(
                                "table",
                                { staticClass: "table table-sm" },
                                [
                                  _c("tr", { staticClass: "text-center" }, [
                                    _c("th", [_vm._v(" ")]),
                                    _c("th", [
                                      _vm._v(_vm._s(_vm.$t("duration"))),
                                    ]),
                                    _c("th", [
                                      _vm._v(_vm._s(_vm.$t("startDate"))),
                                    ]),
                                    _c("th", [
                                      _vm._v(_vm._s(_vm.$t("endDate"))),
                                    ]),
                                    _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("outageModalCommercialValue")
                                        ) +
                                          " (K" +
                                          _vm._s(_vm.modalData.currency) +
                                          ")"
                                      ),
                                    ]),
                                  ]),
                                  _vm._l(
                                    _vm.modalData.details,
                                    function (c, index) {
                                      return _c(
                                        "tr",
                                        { key: "modalDetails-" + index },
                                        [
                                          _c("td", [_vm._v(_vm._s(c.title))]),
                                          _c(
                                            "td",
                                            { staticClass: "text-center" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(c.duration) + " "
                                              ),
                                            ]
                                          ),
                                          _c("td", [
                                            c.startDate
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getFormattedDate(
                                                        c.startDate
                                                      )
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]),
                                          _c("td", [
                                            c.endDate
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getFormattedDate(
                                                        c.endDate
                                                      )
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "doubble-line text-center",
                                            },
                                            [
                                              c.commercialValueIntrinsic != null
                                                ? _c("div", [
                                                    _vm._v(
                                                      " IV: " +
                                                        _vm._s(
                                                          c.commercialValueIntrinsic
                                                        ) +
                                                        " "
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              c.commercialValueExtrinsic != null
                                                ? _c("div", [
                                                    _vm._v(
                                                      " EV: " +
                                                        _vm._s(
                                                          c.commercialValueExtrinsic
                                                        ) +
                                                        " "
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._m(3),
                    ]),
                  ]
                ),
              ]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-footer" }, [
      _c("small", [_vm._v("* IV = Intrinsic Value / EV = Extrinsic Value")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-footer" }, [
      _c("small", [_vm._v("* IV = Intrinsic Value / EV = Extrinsic Value")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }